/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { ClrLoadingButtonModule } from "./button-loading/loading-button.module";
import { ClrButtonGroupModule } from "./button-group/button-group.module";
var ClrButtonModule = (function () {
    function ClrButtonModule() {
    }
    return ClrButtonModule;
}());
export { ClrButtonModule };
ClrButtonModule.decorators = [
    { type: NgModule, args: [{
                exports: [
                    ClrLoadingButtonModule,
                    ClrButtonGroupModule,
                ]
            },] },
];
/** @nocollapse */
ClrButtonModule.ctorParameters = function () { return []; };
//# sourceMappingURL=button.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/button/button.module.js
// module id = 145
// module chunks = 4